import React, { useCallback, useContext, useEffect, useState, useMemo } from 'react';
import { Column }      from 'primereact/column';
import { DataTable }   from 'primereact/datatable';
import { InputText }   from 'primereact/inputtext';
import UserContext from '../../contexts/UserContext';
import UserService from '../../services/UserService';
import EventService from '../../services/EventService';

import './certificationReport.css';

const CertificationReport = () => {
    const userContext = useContext(UserContext);
    const [currentUser, setCurrentUser] = useState(userContext.currentUser);
    const [myCertifications, setMyCertifications] = useState([]);
    const [myContinuingEducation, setMyContinuingEducation] = useState([]);
    const [myRenewalRequirements, setRenewalRequirements] = useState([]);

  const [filterCertifications, setFilterCertifications] = useState('');
  const [filterCEUs, setFilterCEUs] = useState('');
  const [filterCEUProjects, setFilterCEUProjects] = useState('');

  const [loadingCEUs, setLoadingCEUs] = useState(true);
  const [loadingCertifications, setLoadingCertifications] = useState(true);

  const isUsers = (ceu) => {
    return ceu.crm_contact_id === currentUser.crm_id;
  };

  const sortCerts = (certs) => {
    // console.log(evts)
    if (certs === undefined || certs === null) return [];
    return certs.sort(function (a, b) {
      let keyA =
          a.date_earned !== undefined
            ? new Date(a.date_earned)
            : new Date(a.date_earned),
        keyB =
          b.date_earned !== undefined
            ? new Date(b.date_earned)
            : new Date(b.date_earned);
      // Compare the 2 dates
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });
  };

  const normalizeCEUs = useCallback(e => ({
    id: e.id,
    name: e.ceu_name,
    dateEarned: e.date_earned,
    numberOfCredits: e.number_of_credits,
    sessionCode: e.session_code,
    projectNumber: e.project_number,
    projectRole: e.project_role,
    projectName: e.project_name,
  }),[]);

  const filteredContinuingEducation = (items = []) =>
    items.filter(item =>
      item &&
      (typeof item.projectNumber === 'string' ? item.projectNumber.trim() : !!item.projectNumber) &&
      (typeof item.projectRole === 'string' ? item.projectRole.trim() : !!item.projectRole)
    );

  const filteredCEUProjects = useMemo(() => filteredContinuingEducation(myContinuingEducation), [myContinuingEducation]);


  const dateBody = field => row => {
    return (
        <span className='date-body'>
        {row[field]}
        </span>)}
    ;

    const renderBodyCell = field => row => {
        const content = row[field];

        return (
            <span>{content ? content : '--'}</span>
        )
    }
  const standardEventNameBody = row => (
    <span>
      {row?.name}
    </span>
  );

  const projectNameBody = row => (
    <span>
      {row?.name || '--'}
    </span>
  );

  const displayRenewalRequirements = field => row => {
      return (
        row[field] ? (        
        <a href={'https://www.phius.org/maintain-credentials'} target="_blank" rel="noopener noreferrer" className={'register-link'}>
          See Requirements
        </a>) :
        (<div>--</div>)
      );
  };

  useEffect(() => {
    if (Object.keys(userContext.currentUser).length > 0) {
      console.log('UE-user: ', currentUser);
    } else {
      console.log('else1');
      // if(currentUser !== userContext.currentUser){
      UserService.getUserByToken().then((res) => {
        console.log('else2: ', res);
        if (
          userContext.currentUser.crm_contact_id !== res.user.crm_contact_id
        ) {
          console.log('else3');
          if (userContext.currentUser !== res.user) {
            console.log('else4');
            userContext.setCurrentUser(res.user);
          }
        }
        if (currentUser.crm_contact_id !== res.user.crm_contact_id) {
          console.log('else5');
          if (currentUser !== res.user) {
            console.log('else6');
            setCurrentUser(res.user);
          }
        }
      });
      // }
    }
  }, [currentUser, userContext]);

  useEffect(() => {
    let isCancelled = false;
    setLoadingCertifications(true);
    try {
        const user = currentUser;
        const { certifications } = user;
        
        const certs = certifications && certifications?.length > 0 ? certifications : [];
        let renewalBuffer = {
            CPHC: false,
            CPHB: false,
            Rater: false,
            Verifier: false,
        }
        const certsBuffer = certs.map((cert) => {
            if (cert === 'CPHC' || cert === 'CPHB' || cert === 'Rater' || cert === 'Verifier') {
                renewalBuffer[cert] = true;
            }
            const certificationString =
            user[`${cert.toLowerCase()}_certification_date`];
            const certificationDate = certificationString ? new Date(
                certificationString
            ).toLocaleDateString() : '--';
            const expirationString = user[`${cert.toLowerCase()}_expiration_date`];
            const expirationDate = expirationString ? new Date(expirationString).toLocaleDateString() : '--';
            const renewalString = user[`${cert.toLowerCase()}_renewal_date`];
            const renewalDate = renewalString ? new Date(renewalString).toLocaleDateString() : '--';
            const ceuTotal = user[`${cert.toLowerCase()}_ceu_total`];
            const ceuStatus = user[`${cert.toLowerCase()}_status`];
    
          return {
            certification: cert,
            certificationDate,
            expirationDate,
            renewalDate,
            ceuTotal,
            ceuStatus
          }
        });
    
        setMyCertifications(certsBuffer);
        setRenewalRequirements([renewalBuffer]);
        
    } catch (err) {
        console.error('Failed to fetch certifications:', err);
    }
    setLoadingCertifications(false)



    setLoadingCEUs(true)
    EventService.getAllCEUs()
    .then((CEU) => {
        console.log('CEU: ', CEU);
      if (!isCancelled) {
        let sortedCeus = sortCerts(CEU.ceus);
        const ceuBuffer = sortedCeus.filter(isUsers).map(normalizeCEUs);
        setMyContinuingEducation(ceuBuffer);
    }
    })
    .catch(err => {
      console.error('Failed to fetch all CEUs:', err);
    }).finally(() =>
        setLoadingCEUs(false)
    );

  return () => {
    isCancelled = true;
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  return (
    <div className="certifications-container">
        <>
          <div className="table-header">
            <h2>My Certifications</h2>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
                <label htmlFor="search-my-certifications">Search</label>
                <InputText
                id="search-my-certifications"
                variant="filled"
                placeholder="Search…" 
                value={filterCertifications}
                onChange={e => setFilterCertifications(e.target.value)}
                className="search-input-field"
                />
            </div>
          </div>
          <DataTable
            value={myCertifications}
            paginator
            rows={5}
            globalFilter={filterCertifications}
            globalFilterFields={['certification', 'ceuStatus']}
            loading={loadingCertifications}
            emptyMessage="No Certifications"
            responsiveLayout="scroll"
            className="p-datatable-sm custom-datatable"
            tableStyle={{ backgroundColor: '#FEFEFE', color: '#2A2E33', fontSize: '14px', lineHeight: '20px'}}
          >
            <Column field="certification"  header="Certification" sortable/>
            <Column field="certificationDate"    header="Certification Date" align={'center'} alignHeader={'left'} body={dateBody('certificationDate')} sortable/>
            <Column field="renewalDate"      header="Renewal Date"   align={'center'} alignHeader={'left'} body={dateBody('renewalDate')} sortable/>
            <Column field="expirationDate"     header="Expiration Date"    align={'left'} alignHeader={'left'} body={dateBody('expirationDate')}   sortable/>
            <Column field="ceuTotal"   header="Current CEU Total" sortable/>
            <Column field="ceuStatus" header="Status" sortable/>
          </DataTable>

          <div className="table-header">
            <h2>Renewal Requirements</h2>
          </div>
          <DataTable
            value={myRenewalRequirements}
            rows={5}
            loading={loadingCertifications}
            responsiveLayout="scroll"
            className="p-datatable-sm custom-datatable"
            tableStyle={{ backgroundColor: '#FEFEFE', color: '#2A2E33', fontSize: '14px', lineHeight: '20px'}}
          >            
            <Column field="CPHC" header="Phius Certified CPHC" body={displayRenewalRequirements('CPHC')} />
            <Column field="CPHB" header="Phius Certified CPHB" body={displayRenewalRequirements('CPHB')} />
            <Column field="Rater"   header="Phius Certified Rater" body={displayRenewalRequirements('Rater')} />
            <Column field="Verifier" header="Phius Certified Verifier" body={displayRenewalRequirements('Verifier')} />
          </DataTable>

          <div className="table-header">
            <h2>My Continuing Education Units</h2>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
            <label htmlFor="search-my-products">Search</label>
            <InputText
              id='search-my-products'
              variant="filled"
              placeholder="Search…" 
              value={filterCEUs}
              onChange={e => setFilterCEUs(e.target.value)}
              className="search-input-field"
              showClear
            />
            </div>
          </div>
          <DataTable
            value={myContinuingEducation}
            paginator
            rows={5}
            globalFilter={filterCEUs}
            globalFilterFields={['name', 'sessionCode']}
            loading={loadingCEUs}
            emptyMessage="No CEU"
            responsiveLayout="scroll"
            className="p-datatable-sm custom-datatable"
            tableStyle={{ backgroundColor: '#FEFEFE', color: '#2A2E33', fontSize: '14px', lineHeight: '20px'}}
          >
            <Column field="name" header="CEU Name" body={standardEventNameBody} sortable/>
            <Column field="dateEarned"     header="Date Earned" align={'center'} alignHeader={'left'} body={dateBody('dateEarned')} sortable/>
            <Column field="numberOfCredits"  header="Number of Credits" sortable/>
            <Column field="sessionCode" header="Session Code" sortable/>
          </DataTable>

          <div className="table-header">
            <h2>My Continuing Education Projects</h2>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
            <label htmlFor="search-my-projects">Search</label>
            <InputText
              id='search-my-projects'
              variant="filled"
              placeholder="Search…" 
              value={filterCEUProjects}
              onChange={e => setFilterCEUProjects(e.target.value)}
              className="search-input-field"
              showClear
            />
            </div>
          </div>
          <DataTable
            value={filteredCEUProjects}
            paginator
            rows={5}
            globalFilter={filterCEUProjects}
            globalFilterFields={['name', 'projectNumber', 'projectRole']}
            loading={loadingCEUs}
            emptyMessage="No CEU Projects"
            responsiveLayout="scroll"
            className="p-datatable-sm custom-datatable"
            tableStyle={{ backgroundColor: '#FEFEFE', color: '#2A2E33', fontSize: '14px', lineHeight: '20px'}}
          >            
            <Column field="name" header="Project Name" body={projectNameBody} sortable />
            <Column field="projectNumber" header="Project Number" body={renderBodyCell("projectNumber")} sortable/>
            <Column field="projectRole"   header="Project Role" body={renderBodyCell("projectRole")} sortable/>
          </DataTable>
        </>
    </div>
  );
}

export default CertificationReport;
